var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoanApply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 227,
    viewBox: "0 0 200 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_479_5001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.941 76.3738C202.042 96.2972 200.685 121.498 186.605 137.541C165.325 161.786 175.439 184.853 127.311 212.318C119.805 216.599 112.404 219.813 105.164 222.066C101.274 223.278 97.4281 224.21 93.6377 224.875C59.2787 230.969 29.6615 215.507 12.442 190.697C-10.2103 158.07 3.1888 127.336 12.5471 108.394C21.9055 89.4525 17.4692 41.5793 64.5713 14.2103C71.7565 10.0393 79.3724 6.59942 87.3287 4.17597C105.48 -1.36192 127.085 -1.96778 144.771 5.86338C146.097 6.45422 147.409 7.08512 148.706 7.75107C174.032 20.8698 192.348 49.2051 197.936 76.3689L197.941 76.3738Z",
    fill: "#645faa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M197.976 76.3738C202.077 96.2972 200.72 121.498 186.64 137.541C165.36 161.786 175.474 184.853 127.346 212.318C119.84 216.599 112.44 219.813 105.199 222.066C101.309 223.278 97.4632 224.21 93.6728 224.875C59.3139 230.969 29.6967 215.507 12.4771 190.697C-10.1751 158.07 3.22396 127.336 12.5823 108.394C21.9406 89.4525 17.5043 41.5793 64.6064 14.2103C71.7917 10.0393 79.4075 6.59942 87.3639 4.17597C105.515 -1.36192 127.121 -1.96778 144.806 5.86338C146.133 6.45422 147.444 7.08512 148.741 7.75107C174.067 20.8698 192.384 49.2051 197.971 76.3689L197.976 76.3738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9946 55.1132L13.9074 44.0173L13.9023 42.6304L32.9895 53.7212L32.9946 55.1132Z",
    fill: "#2F3E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9895 53.7214L13.9023 42.6306L44.8815 24.7451L63.9687 35.8359L32.9895 53.7214Z",
    fill: "#424E57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9674 35.8359L63.9724 37.2229L32.9933 55.1134L32.9883 53.7214L63.9674 35.8359Z",
    fill: "#536571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9893 50.7771L16.626 41.2685L16.5859 26.167L32.9443 35.6705L32.9893 50.7771Z",
    fill: "#008080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9443 35.6708L16.5859 26.1673L42.1123 11.4263L58.4756 20.9348L32.9443 35.6708Z",
    fill: "#D87A51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4767 20.9346L58.5168 36.0361L32.9904 50.7771L32.9453 35.6706L58.4767 20.9346Z",
    fill: "#66B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5104 36.8274L14.5898 26.4125L42.5547 10.2695L60.4702 20.6844L32.5104 36.8274Z",
    fill: "#D87A51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5104 36.2165L14.5898 25.8017L42.5547 9.65869L60.4702 20.0735L32.5104 36.2165Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2848 40.5276L51.0144 40.3674L50.9844 30.1729L51.2598 30.3281L51.2848 40.5276Z",
    fill: "#EFC585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9645 47.0668L39.6941 46.9065L39.6641 36.2363L39.9344 36.3915L39.9645 47.0668Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9344 36.3918L39.6641 36.2366L51.3958 29.4619L51.6712 29.6171L39.9344 36.3918Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6703 29.6172L51.7004 40.2924L51.2848 40.5277L51.2597 30.3282L40.3492 36.6272L40.3742 46.8267L39.9636 47.0671L39.9336 36.3918L51.6703 29.6172Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8418 36.8425L53.5664 36.6823L56.1701 35.1802L56.4455 35.3404L53.8418 36.8425Z",
    fill: "#EFC585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4467 35.3402L56.1713 35.18L56.1562 28.7559L56.4266 28.9111L56.4467 35.3402Z",
    fill: "#D3A25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4271 37.5537L53.1567 37.3935L53.1367 30.0229L53.4071 30.1832L53.4271 37.5537Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4071 30.183L53.1367 30.0227L56.5616 28.0449L56.837 28.2001L53.4071 30.183Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4062 30.1829L56.8361 28.2051L56.8562 35.5756L53.4263 37.5534L53.4062 30.1829ZM56.4406 35.3402L56.4205 28.9161L53.8168 30.4182L53.8369 36.8424L56.4406 35.3402Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.666 47.3372L35.3906 47.1769L37.9993 45.6748L38.2697 45.83L35.666 47.3372Z",
    fill: "#EFC585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2709 45.83L38.0005 45.6748L37.9805 39.2456L38.2509 39.4058L38.2709 45.83Z",
    fill: "#D3A25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2564 48.0433L34.986 47.8881L34.9609 40.5176L35.2363 40.6728L35.2564 48.0433Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2363 40.6727L34.9609 40.5175L38.3908 38.5347L38.6662 38.6949L35.2363 40.6727Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2344 40.6726L38.6643 38.6948L38.6843 46.0653L35.2544 48.0431L35.2344 40.6726ZM38.2687 45.83L38.2487 39.4058L35.645 40.908L35.665 47.3321L38.2687 45.83Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9516 25.2811L50.2706 24.8856L50.2656 23.3784L50.9466 23.779L50.9516 25.2811Z",
    fill: "#2F3E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9467 23.1978L51.9517 24.7049L50.9503 25.2807L50.9453 23.7786L51.9467 23.1978Z",
    fill: "#536571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9466 23.7786L50.2656 23.3781L51.2671 22.8022L51.948 23.1978L50.9466 23.7786Z",
    fill: "#536571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2113 29.397L41.2163 30.9041L40.2148 31.4799V29.9728L41.2113 29.397Z",
    fill: "#536571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2133 31.4799L39.5324 31.0843L39.5273 29.5771L40.2133 29.9727V31.4799Z",
    fill: "#2F3E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2133 29.9729L39.5273 29.5773L40.5288 29.0015L41.2097 29.397L40.2133 29.9729Z",
    fill: "#536571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0085 31.2495L37.3275 30.854L37.3125 25.5063L37.9935 25.9019L38.0085 31.2495Z",
    fill: "#2F3E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1402 16.5786L54.1552 21.9262L51.9471 23.198L50.9456 23.7789L41.2118 29.3969L40.2154 29.9727L38.0072 31.2495L37.9922 25.9019L54.1402 16.5786Z",
    fill: "#536571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9935 25.902L37.3125 25.5064L53.4605 16.1831L54.1415 16.5787L37.9935 25.902Z",
    fill: "#424E57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0168 40.3674V30.4683L40.3516 36.627L40.3916 46.5061L51.0168 40.3674Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0018 45.675V39.5513L35.6484 40.9082L35.6685 47.0219L38.0018 45.675Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8242 30.4182L53.8392 36.5269L56.1726 35.18L56.1575 29.0713L53.8242 30.4182Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7292 17.2896L38.4023 26.1372L38.4174 30.5384L53.7392 21.6908L53.7292 17.2896Z",
    fill: "#66B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5673 23.4335L58.3821 23.3284C58.2319 23.2382 58.1367 23.053 58.1367 22.7876L58.322 22.8927C58.322 23.1581 58.4171 23.3434 58.5673 23.4335Z",
    fill: "#D3A25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0027 20.9546V21.921C60.0027 22.4567 59.6322 23.1077 59.1665 23.373C58.7009 23.6434 58.3253 23.4281 58.3203 22.8924V21.926L60.0027 20.9546Z",
    fill: "#EABC6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.322 22.8923L58.1367 22.7872V21.8208L58.322 21.926V22.8923Z",
    fill: "#E6E3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.322 21.9261L58.1367 21.821L59.8191 20.8496L60.0044 20.9548L58.322 21.9261Z",
    fill: "#F8F7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8837 24.4047L56.6985 24.2996C56.5483 24.2094 56.4531 24.0242 56.4531 23.7588L56.6384 23.8639C56.6384 24.1293 56.7335 24.3146 56.8837 24.4047Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3191 21.9258V22.8922C58.3191 23.4279 57.9486 24.0788 57.4829 24.3442C57.0173 24.6146 56.6417 24.3993 56.6367 23.8635V22.8972L58.3191 21.9258Z",
    fill: "#6C8BA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6384 23.8635L56.4531 23.7584V22.792L56.6384 22.8971V23.8635Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6384 22.8973L56.4531 22.7922L58.1355 21.8208L58.3208 21.926L56.6384 22.8973Z",
    fill: "#DB6564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2001 25.3813L55.0149 25.2761C54.8647 25.186 54.7695 25.0007 54.7695 24.7354L54.9548 24.8405C54.9548 25.1059 55.0499 25.2911 55.2001 25.3813Z",
    fill: "#D3A25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6394 22.8975V23.8638C56.6394 24.3996 56.2689 25.0505 55.8032 25.3159C55.3376 25.5863 54.962 25.371 54.957 24.8352V23.8688L56.6394 22.8975Z",
    fill: "#EABC6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9559 24.8402L54.7706 24.73L54.7656 23.7637L54.9509 23.8738L54.9559 24.8402Z",
    fill: "#E6E3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9509 23.874L54.7656 23.7639L56.453 22.7925L56.6383 22.8976L54.9509 23.874Z",
    fill: "#F8F7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5166 26.3525L53.3313 26.2473C53.1811 26.1572 53.0859 25.9719 53.0859 25.7065L53.2712 25.8117C53.2712 26.0771 53.3663 26.2623 53.5166 26.3525Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.948 23.874V24.8404C54.948 25.3762 54.5775 26.0271 54.1118 26.2925C53.6462 26.5629 53.2706 26.3475 53.2656 25.8118V24.8454L54.948 23.874Z",
    fill: "#6C8BA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2723 25.8114L53.087 25.7012L53.082 24.7349L53.2673 24.845L53.2723 25.8114Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2673 24.8452L53.082 24.7351L54.7644 23.7637L54.9497 23.8738L53.2673 24.8452Z",
    fill: "#DB6564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.833 27.3241L51.6477 27.219C51.4975 27.1289 51.4023 26.9436 51.4023 26.6782L51.5876 26.7834C51.5876 27.0488 51.6827 27.234 51.833 27.3241Z",
    fill: "#D3A25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2683 24.8457V25.8121C53.2683 26.3478 52.8978 26.9988 52.4321 27.2642C51.9665 27.5345 51.5909 27.3192 51.5859 26.7835V25.8171L53.2683 24.8457Z",
    fill: "#EABC6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5876 26.7831L51.4023 26.6729V25.7065L51.5876 25.8167V26.7831Z",
    fill: "#E6E3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5876 25.8169L51.4023 25.7067L53.0847 24.7354L53.27 24.8455L51.5876 25.8169Z",
    fill: "#F8F7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1494 28.2953L49.9641 28.1902C49.8139 28.1001 49.7188 27.9148 49.7188 27.6494L49.904 27.7546C49.904 28.0199 49.9991 28.2052 50.1494 28.2953Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5847 25.8169V26.7833C51.5847 27.319 51.2142 27.97 50.7486 28.2353C50.2829 28.5057 49.9074 28.2904 49.9023 27.7547V26.7883L51.5847 25.8169Z",
    fill: "#6C8BA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.904 27.7543L49.7188 27.6441V26.6777L49.904 26.7879V27.7543Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.904 26.7881L49.7188 26.6779L51.4011 25.7065L51.5864 25.8167L49.904 26.7881Z",
    fill: "#DB6564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4658 29.267L48.2805 29.1619C48.1303 29.0717 48.0352 28.8865 48.0352 28.6211L48.2204 28.7262C48.2204 28.9916 48.3156 29.1769 48.4658 29.267Z",
    fill: "#D3A25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9051 26.7886V27.755C49.9051 28.2907 49.5345 28.9416 49.0689 29.207C48.6032 29.4774 48.2277 29.2621 48.2227 28.7263V27.76L49.9051 26.7886Z",
    fill: "#EABC6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2215 28.7263L48.0363 28.6212L48.0312 27.6548L48.2165 27.7599L48.2215 28.7263Z",
    fill: "#E6E3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2165 27.7598L48.0312 27.6546L49.7187 26.6782L49.9039 26.7884L48.2165 27.7598Z",
    fill: "#F8F7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7822 30.2387L46.5969 30.1335C46.4467 30.0434 46.3516 29.8582 46.3516 29.5928L46.5368 29.6979C46.5368 29.9633 46.632 30.1486 46.7822 30.2387Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2136 27.7598V28.7261C48.2136 29.2619 47.8431 29.9128 47.3775 30.1782C46.9118 30.4486 46.5363 30.2333 46.5312 29.6975V28.7312L48.2136 27.7598Z",
    fill: "#6C8BA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5379 29.6975L46.3527 29.5924L46.3477 28.626L46.5329 28.7311L46.5379 29.6975Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5329 28.7313L46.3477 28.6262L48.0301 27.6548L48.2153 27.7599L46.5329 28.7313Z",
    fill: "#DB6564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0986 31.2094L44.9133 31.1042C44.7631 31.0141 44.668 30.8289 44.668 30.5635L44.8532 30.6686C44.8532 30.934 44.9484 31.1193 45.0986 31.2094Z",
    fill: "#D3A25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.534 28.7305V29.6968C46.534 30.2326 46.1634 30.8835 45.6978 31.1489C45.2321 31.4193 44.8566 31.204 44.8516 30.6682V29.7019L46.534 28.7305Z",
    fill: "#EABC6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8532 30.6682L44.668 30.5631V29.5967L44.8532 29.7018V30.6682Z",
    fill: "#E6E3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8532 29.702L44.668 29.5969L46.3504 28.6255L46.5356 28.7306L44.8532 29.702Z",
    fill: "#F8F7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.415 32.1806L43.2297 32.0754C43.0795 31.9853 42.9844 31.8 42.9844 31.5347L43.1696 31.6398C43.1696 31.9052 43.2648 32.0905 43.415 32.1806Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8504 29.7017V30.668C44.8504 31.2038 44.4798 31.8547 44.0142 32.1201C43.5485 32.3905 43.173 32.1752 43.168 31.6394V30.673L44.8504 29.7017Z",
    fill: "#6C8BA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1696 31.6394L42.9844 31.5342V30.5679L43.1696 30.673V31.6394Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1696 30.6732L42.9844 30.5681L44.6668 29.5967L44.852 29.7018L43.1696 30.6732Z",
    fill: "#DB6564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7314 33.1523L41.5461 33.0471C41.3959 32.957 41.3008 32.7717 41.3008 32.5063L41.486 32.6115C41.486 32.8769 41.5812 33.0621 41.7314 33.1523Z",
    fill: "#D3A25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1707 30.6733V31.6397C43.1707 32.1755 42.8002 32.8264 42.3345 33.0918C41.8688 33.3622 41.4933 33.1469 41.4883 32.6111V31.6447L43.1707 30.6733Z",
    fill: "#EABC6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4871 32.6161L41.3019 32.5059L41.2969 31.5396L41.4821 31.6497L41.4871 32.6161Z",
    fill: "#E6E3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4821 31.6499L41.2969 31.5397L42.9843 30.5684L43.1695 30.6735L41.4821 31.6499Z",
    fill: "#F8F7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0478 34.1235L39.8625 34.0183C39.7123 33.9282 39.6172 33.7429 39.6172 33.4775L39.8025 33.5827C39.8025 33.8481 39.8976 34.0333 40.0478 34.1235Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4793 31.6499V32.6163C41.4793 33.152 41.1087 33.803 40.6431 34.0683C40.1774 34.3387 39.8019 34.1234 39.7969 33.5877V32.6213L41.4793 31.6499Z",
    fill: "#6C8BA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8036 33.5873L39.6183 33.4771L39.6133 32.5107L39.7985 32.6209L39.8036 33.5873Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7985 32.6211L39.6133 32.5109L41.2957 31.5396L41.4809 31.6497L39.7985 32.6211Z",
    fill: "#DB6564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3681 35.1L38.1829 34.9949C38.0326 34.9047 37.9375 34.7195 37.9375 34.4541L38.1228 34.5593C38.1228 34.8246 38.2179 35.0099 38.3681 35.1Z",
    fill: "#D3A25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7996 32.6216V33.588C39.7996 34.1237 39.4291 34.7747 38.9634 35.04C38.4977 35.3104 38.1222 35.0951 38.1172 34.5593V33.593L39.7996 32.6216Z",
    fill: "#EABC6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1239 34.559L37.9386 34.4488L37.9336 33.4824L38.1189 33.5926L38.1239 34.559Z",
    fill: "#E6E3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1189 33.5928L37.9336 33.4826L39.616 32.5112L39.8013 32.6214L38.1189 33.5928Z",
    fill: "#F8F7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6806 36.0712L36.4953 35.9661C36.3451 35.8759 36.25 35.6907 36.25 35.4253L36.4353 35.5304C36.4353 35.7958 36.5304 35.9811 36.6806 36.0712Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.116 33.5928V34.5592C38.116 35.0949 37.7455 35.7458 37.2798 36.0112C36.8141 36.2816 36.4386 36.0663 36.4336 35.5305V34.5642L38.116 33.5928Z",
    fill: "#6C8BA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4353 35.5301L36.25 35.42V34.4536L36.4353 34.5638V35.5301Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4353 34.564L36.25 34.4538L37.9324 33.4824L38.1177 33.5926L36.4353 34.564Z",
    fill: "#DB6564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.997 37.0429L34.8118 36.9377C34.6615 36.8476 34.5664 36.6624 34.5664 36.397L34.7517 36.5021C34.7517 36.7675 34.8468 36.9528 34.997 37.0429Z",
    fill: "#D3A25C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4324 34.5645V35.5308C36.4324 36.0666 36.0619 36.7175 35.5962 36.9829C35.1305 37.2533 34.755 37.038 34.75 36.5022V35.5358L36.4324 34.5645Z",
    fill: "#EABC6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7517 36.5022L34.5664 36.392V35.4307L34.7517 35.5358V36.5022Z",
    fill: "#E6E3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7517 35.5356L34.5664 35.4305L36.2488 34.4541L36.4341 34.5643L34.7517 35.5356Z",
    fill: "#F8F7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3134 38.0146L33.1282 37.9094C32.9779 37.8193 32.8828 37.634 32.8828 37.3687L33.0681 37.4738C33.0681 37.7392 33.1632 37.9244 33.3134 38.0146Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7527 35.5356V36.502C34.7527 37.0378 34.3822 37.6887 33.9165 37.9541C33.4509 38.2245 33.0753 38.0092 33.0703 37.4734V36.507L34.7527 35.5356Z",
    fill: "#6C8BA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0692 37.4734L32.8839 37.3682L32.8789 36.4019L33.0642 36.507L33.0692 37.4734Z",
    fill: "#5F7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0642 36.5072L32.8789 36.402L34.5663 35.4307L34.7516 35.5358L33.0642 36.5072Z",
    fill: "#DB6564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4677 20.0737V20.6846L32.5078 36.8276V36.2167L60.4677 20.0737Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5898 25.8018V26.4126L32.5104 36.8275V36.2166L14.5898 25.8018Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0547 43.2414V33.3372L46.3902 33.147V43.0461L46.0547 43.2414Z",
    fill: "#424E57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1892 38.6498C47.1892 38.8 47.069 38.9202 46.9188 38.9202C46.7686 38.9202 46.6484 38.8 46.6484 38.6498C46.6484 38.4996 46.7686 38.3794 46.9188 38.3794C47.069 38.3794 47.1892 38.4996 47.1892 38.6498Z",
    fill: "#E6E3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8884 39.3461C45.8884 39.4963 45.7683 39.6165 45.618 39.6165C45.4678 39.6165 45.3477 39.4963 45.3477 39.3461C45.3477 39.1959 45.4678 39.0757 45.618 39.0757C45.7683 39.0757 45.8884 39.1959 45.8884 39.3461Z",
    fill: "#E6E3D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5845 23.979C43.6696 23.929 43.7046 23.954 43.7046 24.0441V24.4948C43.7046 24.5899 43.6696 24.65 43.5895 24.7001L42.8284 25.1407C42.7733 25.1757 42.7382 25.2358 42.7382 25.3059C42.7382 25.376 42.7683 25.4011 42.8284 25.376L43.3141 25.1707C43.6245 25.0456 43.8248 25.0806 43.8298 25.5012V25.8968C43.8298 26.3274 43.5744 26.7079 43.1538 26.9533L42.1174 27.5491C42.0373 27.5942 41.9972 27.5742 41.9972 27.484V27.0434C41.9972 26.9483 42.0322 26.8882 42.1124 26.8381L42.9936 26.3274C43.0487 26.2973 43.0787 26.2272 43.0787 26.1672C43.0787 26.077 43.0487 26.062 42.9936 26.087L42.5029 26.2923C42.1975 26.4175 41.9922 26.3825 41.9922 25.9619V25.5663C41.9922 25.1357 42.2425 24.7551 42.6682 24.5098L43.5845 23.979Z",
    fill: "#424E57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0979 22.5271C46.178 22.482 46.2181 22.5021 46.2181 22.5922V25.0357C46.2231 25.1308 46.188 25.1909 46.1079 25.241L45.5972 25.5364C45.5171 25.5815 45.477 25.5614 45.477 25.4713V24.6351L44.9262 24.9506V25.7867C44.9262 25.8819 44.8912 25.942 44.806 25.992L44.3003 26.2825C44.2202 26.3275 44.1802 26.3075 44.1802 26.2174V23.7739C44.1751 23.6787 44.2102 23.6187 44.2903 23.5686L44.796 23.2782C44.8812 23.2281 44.9162 23.2531 44.9162 23.3433V24.1594L45.467 23.844V23.0278C45.467 22.9327 45.502 22.8726 45.5822 22.8225L46.0929 22.5271H46.0979Z",
    fill: "#424E57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6571 21.5755C48.4782 21.1048 48.6735 21.3001 48.6735 21.7607V23.0476C48.6735 23.5032 48.4833 23.9288 47.6621 24.4045C46.8409 24.8752 46.6406 24.6849 46.6406 24.2243V22.9374C46.6406 22.4818 46.8359 22.0512 47.6571 21.5755ZM47.9375 23.338V22.3215C47.9375 22.2264 47.8974 22.1713 47.6571 22.3065C47.4217 22.4417 47.3817 22.5419 47.3817 22.637V23.6534C47.3817 23.7536 47.4267 23.8037 47.6621 23.6685C47.9024 23.5283 47.9375 23.4381 47.9375 23.333",
    fill: "#424E57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2098 20.1589C50.8056 19.8134 50.9859 20.0087 50.9859 20.4443V20.93C50.9859 21.3656 50.8106 21.7662 50.2148 22.1117L49.8392 22.327V22.9529C49.8392 23.048 49.8042 23.1081 49.7241 23.1581L49.2184 23.4486C49.1332 23.4986 49.0982 23.4736 49.0982 23.3835V20.94C49.0932 20.8449 49.1232 20.7848 49.2083 20.7347L50.2098 20.1589ZM50.2799 21.2104V21.0101C50.2799 20.9099 50.2498 20.8398 50.1246 20.915L49.8292 21.0852V21.656L50.1246 21.4858C50.2548 21.4107 50.2799 21.3105 50.2799 21.2104Z",
    fill: "#424E57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9429 42.0347L52.9479 43.1262L42.3878 49.2199L42.3828 48.1334L52.9429 42.0347Z",
    fill: "#424E57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3811 48.1336L41.625 47.6929L52.1851 41.5942L52.9411 42.0349L42.3811 48.1336Z",
    fill: "#536571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1836 41.5942V42.4705L52.9447 43.1264L52.9397 42.0349L52.1836 41.5942Z",
    fill: "#424E57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91221 192.464C11.0288 192.675 13.4973 192.049 13.4973 192.049C13.5224 192.044 12.591 190.547 12.5209 190.462C11.7148 189.445 9.56171 187.963 8.20477 188.474C7.22838 188.844 6.89791 189.981 7.34355 190.877C7.7992 191.793 8.96085 192.284 9.91221 192.464Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0658 218.346H30.0021C29.9671 218.271 29.937 218.196 29.902 218.116C29.6166 217.48 29.3011 216.804 28.9707 216.113C29.1209 216.008 29.9721 215.417 30.6931 214.761C31.5944 215.377 33.6623 215.868 33.9277 215.933C33.8176 216.609 33.7024 217.27 33.5872 217.891C33.5572 218.046 33.5272 218.196 33.5021 218.351H34.3834C34.3984 218.246 34.4184 218.146 34.4385 218.041C34.5536 217.355 34.6638 216.614 34.7639 215.858C35.0443 215.853 37.3176 215.793 38.2789 215.332C39.1502 214.911 40.1466 214.135 40.3469 213.134C40.5472 212.152 39.9313 211.136 38.8948 211.036C37.4527 210.896 35.7553 212.883 35.2396 214.075C35.2096 214.145 34.9642 214.941 34.819 215.447C34.8591 215.137 34.9041 214.836 34.9392 214.516C35.0193 213.885 35.0794 213.249 35.1495 212.568C35.1695 212.238 35.1945 211.907 35.2146 211.567C35.2446 211.231 35.2296 210.876 35.2396 210.53C35.2446 209.724 35.2146 208.903 35.1645 208.082C35.7203 208.152 37.6881 208.367 38.6194 208.082C39.5457 207.801 40.6473 207.185 40.9978 206.224C41.3433 205.283 40.8927 204.186 39.8762 203.926C38.4692 203.565 36.4914 205.278 35.8004 206.374C35.7553 206.444 35.3498 207.285 35.1344 207.751C35.0994 207.255 35.0694 206.765 35.0143 206.264C34.8641 204.822 34.6738 203.37 34.4835 201.918C34.4234 201.472 34.3734 201.032 34.3183 200.586C34.5136 200.611 36.8519 200.921 37.8934 200.601C38.8197 200.321 39.9213 199.705 40.2718 198.743C40.6173 197.802 40.1666 196.705 39.1502 196.445C37.7432 196.085 35.7653 197.797 35.0744 198.894C35.0243 198.974 34.4385 200.19 34.3033 200.506C34.1831 199.529 34.0779 198.553 34.0078 197.587C33.9127 196.255 33.8927 194.938 33.9628 193.666C34.0529 193.681 36.4914 194.012 37.5579 193.686C38.4842 193.406 39.5858 192.785 39.9363 191.823C40.2818 190.882 39.8311 189.786 38.8147 189.525C37.4077 189.165 35.4299 190.877 34.7389 191.974C34.6838 192.059 34.0579 193.366 33.9628 193.611C33.9628 193.536 33.9628 193.456 33.9678 193.381C34.0629 192.024 34.3283 190.717 34.6337 189.51C34.809 188.809 35.0193 188.143 35.2346 187.507C35.6802 187.617 37.7331 188.088 38.7246 187.903C39.6759 187.723 40.8376 187.232 41.2932 186.316C41.7389 185.419 41.4084 184.278 40.432 183.912C39.0751 183.401 36.922 184.884 36.1158 185.9C36.0708 185.955 35.6902 186.566 35.4148 187.012C35.515 186.726 35.6151 186.426 35.7203 186.155C36.1058 185.129 36.5264 184.213 36.902 183.406C37.1173 182.951 37.3276 182.54 37.5229 182.16C38.0186 182.034 40.0014 181.519 40.7825 180.903C41.5436 180.307 42.3497 179.336 42.3297 178.309C42.3097 177.308 41.4935 176.447 40.457 176.572C39.015 176.742 37.7882 179.055 37.5379 180.322C37.5178 180.432 37.3776 182.19 37.4027 182.185C37.4027 182.185 37.4277 182.18 37.4327 182.18C37.2374 182.545 37.0271 182.936 36.8118 183.366C36.4163 184.168 35.9807 185.079 35.5701 186.1C35.1545 187.122 34.7389 188.238 34.4034 189.46C34.0629 190.682 33.7725 191.984 33.6423 193.366C33.6423 193.381 33.6423 193.396 33.6423 193.416C33.5522 193 33.2718 191.843 33.2367 191.758C32.7861 190.542 31.2038 188.459 29.7568 188.524C28.7153 188.569 28.0443 189.55 28.1895 190.542C28.3348 191.553 29.2861 192.384 30.1323 192.85C31.0887 193.376 33.447 193.556 33.6323 193.571C33.5221 194.888 33.5171 196.25 33.5822 197.627C33.6223 198.413 33.6824 199.204 33.7575 200C33.6724 199.645 33.5872 199.324 33.5722 199.279C33.1216 198.062 31.5393 195.984 30.0923 196.044C29.0458 196.09 28.3798 197.071 28.525 198.062C28.6702 199.074 29.6216 199.905 30.4678 200.371C31.329 200.846 33.3369 201.037 33.8676 201.082C33.8977 201.387 33.9277 201.687 33.9578 201.993C34.113 203.45 34.2782 204.902 34.3934 206.334C34.4334 206.84 34.4585 207.336 34.4785 207.836C34.3984 207.521 34.3333 207.255 34.3183 207.215C33.8676 205.999 32.2854 203.921 30.8383 203.981C29.7918 204.026 29.1259 205.007 29.2711 205.999C29.4163 207.01 30.3677 207.841 31.2139 208.307C32.035 208.758 33.8877 208.953 34.5186 209.008C34.5286 209.519 34.5386 210.029 34.5186 210.525C34.4985 210.866 34.5086 211.191 34.4735 211.527C34.4435 211.862 34.4134 212.197 34.3884 212.523C34.3083 213.154 34.2332 213.81 34.143 214.426C34.0829 214.856 34.0179 215.262 33.9528 215.672C33.9177 215.172 33.8276 214.19 33.8126 214.105C33.6373 213.264 33.0264 211.967 32.2153 211.146C32.1902 211.021 32.1552 210.901 32.1051 210.78C31.7296 209.849 30.6581 209.343 29.7317 209.829C28.4499 210.505 28.1345 213.104 28.3598 214.381C28.3748 214.456 28.6101 215.257 28.7654 215.758C28.6302 215.477 28.5 215.202 28.3548 214.911C28.0744 214.341 27.774 213.78 27.4535 213.174C27.2883 212.888 27.123 212.598 26.9578 212.303C26.7976 212.007 26.5923 211.717 26.407 211.421C25.9664 210.745 25.4907 210.079 24.99 209.424C25.4907 209.173 27.2532 208.267 27.8691 207.521C28.485 206.775 29.0608 205.653 28.8255 204.657C28.5951 203.68 27.6137 203.014 26.6273 203.36C25.2554 203.836 24.5494 206.354 24.5794 207.651C24.5794 207.731 24.7046 208.657 24.7847 209.168C24.4843 208.773 24.1838 208.382 23.8634 207.991C22.9471 206.87 21.9807 205.763 21.0243 204.657C20.7289 204.316 20.4435 203.976 20.1531 203.635C20.3334 203.55 22.4514 202.514 23.1424 201.677C23.7582 200.931 24.3341 199.81 24.0987 198.813C23.8684 197.837 22.887 197.171 21.9006 197.517C20.5286 197.992 19.8226 200.511 19.8527 201.808C19.8527 201.903 20.0379 203.24 20.098 203.575C19.4621 202.824 18.8312 202.073 18.2404 201.302C17.4242 200.245 16.6832 199.159 16.0422 198.057C16.1274 198.017 18.3405 196.951 19.0515 196.09C19.6674 195.343 20.2432 194.222 20.0079 193.225C19.7776 192.249 18.7962 191.583 17.8098 191.929C16.4378 192.404 15.7318 194.923 15.7618 196.22C15.7618 196.32 15.9621 197.757 16.0172 198.012C15.9771 197.947 15.9321 197.882 15.897 197.817C15.2261 196.63 14.7304 195.399 14.3198 194.217C14.0794 193.531 13.8892 192.865 13.7189 192.214C14.1495 192.059 16.1224 191.318 16.8484 190.617C17.5444 189.941 18.2404 188.894 18.1152 187.878C17.99 186.881 17.0887 186.115 16.0723 186.346C14.6603 186.666 13.6789 189.095 13.5687 190.386C13.5637 190.456 13.5787 191.178 13.5988 191.703C13.5236 191.408 13.4435 191.102 13.3784 190.817C13.1331 189.745 12.9779 188.754 12.8477 187.873C12.7776 187.372 12.7225 186.916 12.6774 186.491C13.0229 186.115 14.3899 184.588 14.7053 183.647C15.0108 182.73 15.146 181.474 14.5651 180.632C13.9993 179.806 12.8427 179.541 12.0465 180.217C10.94 181.153 11.1903 183.757 11.686 184.954C11.7311 185.059 12.5823 186.596 12.6023 186.581C12.6023 186.581 12.6174 186.561 12.6224 186.556C12.6574 186.967 12.7025 187.407 12.7576 187.888C12.8727 188.774 13.0079 189.776 13.2282 190.852C13.4485 191.929 13.7139 193.095 14.1095 194.302C14.5 195.509 14.9757 196.755 15.6317 197.977C15.6367 197.992 15.6467 198.002 15.6567 198.017C15.3563 197.717 14.48 196.916 14.4049 196.861C13.3584 196.095 10.8899 195.233 9.71823 196.085C8.87202 196.7 8.857 197.882 9.52295 198.633C10.2039 199.399 11.4557 199.564 12.4171 199.489C13.5036 199.399 15.5716 198.253 15.7368 198.157C16.3727 199.319 17.1138 200.456 17.9349 201.567C18.4006 202.203 18.8913 202.829 19.392 203.45C19.1216 203.2 18.8763 202.979 18.8412 202.954C17.7947 202.188 15.3262 201.327 14.1545 202.178C13.3083 202.789 13.2933 203.976 13.9593 204.727C14.6402 205.493 15.892 205.658 16.8534 205.583C17.8298 205.503 19.6123 204.557 20.083 204.301C20.2783 204.537 20.4685 204.777 20.6638 205.012C21.6002 206.144 22.5365 207.265 23.4228 208.397C23.7332 208.793 24.0286 209.198 24.324 209.599C24.0837 209.378 23.8784 209.193 23.8484 209.168C22.8019 208.402 20.3334 207.541 19.1617 208.392C18.3155 209.008 18.3005 210.19 18.9664 210.941C19.6474 211.707 20.8992 211.872 21.8605 211.797C22.7919 211.722 24.4492 210.861 25.005 210.56C25.2954 210.981 25.5858 211.401 25.8462 211.822C26.0165 212.112 26.2017 212.383 26.3619 212.683C26.5222 212.979 26.6824 213.274 26.8426 213.564C27.128 214.135 27.4235 214.721 27.6838 215.287C27.8691 215.677 28.0393 216.053 28.2096 216.434C27.9041 216.033 27.2883 215.262 27.2282 215.207C26.3119 214.29 24.0036 213.064 22.7117 213.73C21.7804 214.21 21.5851 215.377 22.1309 216.218C22.6867 217.074 23.8984 217.43 24.8648 217.5C25.9263 217.575 28.0594 216.794 28.3298 216.694C28.5951 217.28 28.8455 217.851 29.0758 218.401L29.0658 218.346Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1367 187.242C35.1617 187.252 35.2068 185.489 35.2018 185.379C35.0866 184.087 34.1102 181.664 32.6982 181.339C31.6818 181.108 30.7755 181.874 30.6553 182.871C30.5301 183.887 31.2261 184.939 31.9221 185.61C32.7383 186.401 35.1417 187.242 35.1417 187.242H35.1367Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2369 164.089C90.2369 164.089 71.2949 167.689 69.1969 170.553C67.1039 173.422 61.9015 188.674 61.4609 189.34C61.0202 190.001 52.0875 203.345 50.7656 207.2C49.4437 211.061 50.4352 214.476 53.7449 216.574C57.0546 218.667 60.4695 217.675 62.1268 217.675C63.7842 217.675 68.0803 214.035 68.4108 212.493C68.7412 210.951 69.7327 206.76 69.7327 206.76L75.9065 195.954L79.6568 218.446H131.145L134.675 196.951L145.481 216.799H163.341L152.205 193.095L146.031 181.959C146.031 181.959 143.608 173.687 139.858 170.273C136.107 166.853 130.925 165.751 129.162 165.641C127.4 165.531 122.658 164.429 120.23 163.878C117.806 163.328 112.734 161.675 112.734 161.675L90.2419 164.099L90.2369 164.089Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0781 201.893C55.0781 201.893 61.1267 200.961 66.895 205.893",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.328 205.498C142.713 203.335 148.897 199.68 154.5 197.977L152.201 193.085L146.028 181.949C146.028 181.949 143.604 173.678 139.854 170.263C136.103 166.848 130.921 165.741 129.159 165.631C127.396 165.521 122.654 164.419 120.226 163.869C117.802 163.318 112.73 161.666 112.73 161.666L90.2381 164.089C90.2381 164.089 73.0536 166.883 69.1981 170.553C64.4013 175.12 61.9027 188.674 61.4621 189.34C61.2618 189.645 59.2739 192.615 57.0508 196.11C59.4342 198.057 64.8219 201.958 71.5114 203.64L75.9026 195.954L79.653 218.446H131.141L134.671 196.951L139.328 205.503V205.498Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2362 164.089C90.2362 164.089 90.1211 164.129 89.9258 164.194L90.787 166.843C90.787 166.843 92.219 175.445 95.4186 178.419C98.6182 181.399 102.584 181.839 108.317 177.648C114.05 173.457 115.813 168.385 115.923 166.072L116.033 163.759L115.617 162.577C114.02 162.086 112.723 161.666 112.723 161.666L90.2312 164.089H90.2362Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8281 183.246C91.1386 184.157 91.4941 185.024 91.8946 185.81",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4766 168.17C88.4766 168.17 88.6067 174.829 90.1039 180.768",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0534 167.729C86.0534 167.729 84.1808 172.801 84.9519 175.665",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.027 186.301C127.208 187.117 127.443 187.918 127.728 188.679",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.846 173.903C126.846 173.903 125.84 180.012 126.871 185.554",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.223 180.077C121.223 180.077 122.214 184.047 123.205 185.81",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.156 190.882L134.678 196.946L130.377 193.967",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9086 195.954C75.9086 195.954 74.4765 189.67 73.7054 186.912C72.9343 184.158 73.0445 179.306 73.0445 179.306",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8555 181.619C67.8555 181.619 69.2875 184.598 72.0464 186.251",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7695 170.593C93.7695 170.593 95.532 176.216 100.164 177.648C104.795 179.08 112.181 170.263 112.732 167.834C113.282 165.411 113.282 162.872 113.282 162.542C113.282 162.211 112.401 154.16 112.401 154.16C112.401 154.16 109.312 159.232 105.016 164.304C100.714 169.376 93.7695 170.588 93.7695 170.588V170.593Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7695 170.593C93.7695 170.593 95.2016 175.145 98.8618 177.102C100.214 175.705 101.726 173.853 102.482 171.915C104.024 167.944 105.016 164.309 105.016 164.309C100.714 169.381 93.7695 170.593 93.7695 170.593Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0771 140.715C85.0771 140.715 85.653 153.529 85.9434 155.451C86.2338 157.379 88.2567 162.582 88.7374 164.024C89.218 165.471 92.3976 170.959 95.1916 171.73C97.9855 172.501 100.008 171.439 101.836 170.573C103.664 169.707 107.81 164.89 108.581 163.543C109.352 162.196 110.989 159.017 111.565 157.765L112.141 156.513C112.141 156.513 112.717 144.281 112.817 142.738C112.912 141.196 114.164 134.842 112.722 132.624C111.274 130.411 105.787 127.517 99.718 127.326C93.6494 127.136 88.2567 128.673 86.2338 131.372C84.2109 134.071 83.8254 138.983 85.0771 140.715Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8482 139.754C85.8482 139.078 87.0049 138.888 87.0049 138.888C87.0049 138.888 92.9784 143.414 96.5385 143.224C100.104 143.034 104.435 139.854 106.072 140.139C107.709 140.43 107.905 141.872 107.419 144.28C106.938 146.689 106.648 150.154 107.419 150.254C108.19 150.349 109.537 149.773 109.537 149.773C109.537 149.773 109.347 152.277 110.308 152.372C111.269 152.467 112.141 151.31 112.141 151.025C112.141 150.74 112.431 146.884 112.431 146.884C112.431 146.884 112.496 146.854 112.606 146.799C112.702 144.846 112.782 143.239 112.817 142.743C112.912 141.201 114.164 134.847 112.722 132.629C111.274 130.416 105.787 127.522 99.718 127.331C93.6494 127.141 88.2567 128.678 86.2338 131.377C84.2109 134.076 83.8254 138.988 85.0771 140.72C85.0771 140.72 85.8482 140.43 85.8482 139.759V139.754Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.219 153.043C110.219 153.043 111.18 148.421 112.918 148.612C114.65 148.802 114.46 153.233 113.303 154.871C112.146 156.508 110.99 156.798 110.99 156.798",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.219 153.043C110.219 153.043 111.18 148.421 112.918 148.612C114.65 148.802 114.46 153.233 113.303 154.871C112.146 156.508 110.99 156.798 110.99 156.798",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4556 154.585C93.4556 154.585 93.1652 161.615 93.3605 162.196C93.5508 162.772 94.2267 163.543 95.9592 163.543C97.6917 163.543 98.1723 163.063 98.4628 162.196",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.918 164.604C91.918 164.604 92.5939 165.566 93.4602 165.856C94.3264 166.147 97.0252 166.242 98.3722 166.047C99.7191 165.856 100.971 165.085 101.166 164.795",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1599 153.118C98.1599 153.118 103.768 152.818 104.434 152.713C105.1 152.607 102.701 151.621 100.658 151.651C98.6155 151.681 96.6477 152.187 98.1599 153.118Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7794 153.093C92.7794 153.093 87.1664 152.848 86.5005 152.753C85.8345 152.652 88.2229 151.641 90.2658 151.651C92.3088 151.661 94.2816 152.147 92.7794 153.093Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3516 156.223C88.3516 156.223 89.5082 157.955 92.6877 156.798",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9102 156.698C98.9102 156.698 100.372 158.676 103.782 156.984",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13 202.018C122.13 202.018 113.418 205.327 112.977 205.658C112.536 205.988 108.235 209.959 108.015 210.51L107.795 211.061C107.795 211.061 107.684 211.832 108.455 211.832C108.455 211.832 107.574 213.154 108.345 213.815C109.116 214.475 110.218 213.925 110.218 213.925C110.218 213.925 109.227 215.467 110.328 215.797C111.43 216.128 112.862 215.908 112.862 215.908C112.862 215.908 112.641 216.458 116.502 217.229C120.362 218 124.438 218.331 126.206 218C127.968 217.67 131.939 217.229 131.939 217.229C131.939 217.229 149.579 218.661 153.109 218.331C156.639 218 162.262 218.551 163.364 216.789C164.465 215.026 162.813 211.827 161.491 209.844C160.169 207.861 157.08 204.111 153.445 204.001C151.241 203.935 147.381 204.661 145.398 205.543C143.415 206.424 138.784 208.297 138.343 208.412C137.902 208.522 133.161 208.192 133.161 208.192C133.161 208.192 124.008 202.128 123.457 202.018C122.906 201.908 122.135 202.018 122.135 202.018H122.13Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.461 211.832L115.186 208.192L122.796 206.319",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.223 213.925L116.507 211.612L123.457 210.285",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.871 215.907L119.045 215.026L124.558 214.365",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5738 203.004C61.5738 203.004 66.8663 205.648 67.4171 205.763C67.9679 205.878 71.3878 205.653 71.6081 208.076C71.8284 210.5 69.6253 213.809 69.1846 215.241C68.744 216.673 63.5616 216.343 63.5616 216.343C63.5616 216.343 61.7991 210.389 61.3585 208.186C60.9179 205.983 61.5788 203.004 61.5788 203.004H61.5738Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4805 193.856L65.8746 214.916L67.7823 216.789L67.7322 214.035L61.1729 193.265L59.4805 193.856Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1729 193.265L59.4805 193.856L60.2315 196.33L61.959 195.749L61.1729 193.265Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8672 215.247C52.8672 215.247 53.5281 217.119 54.1891 217.34C54.85 217.56 58.6004 217.45 59.7019 217.45C60.8035 217.45 52.8672 215.247 52.8672 215.247Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4089 211.055C54.4089 211.055 52.6464 214.365 52.8667 215.246C53.087 216.127 54.7394 216.568 56.1764 216.898C57.6085 217.229 60.9182 217.339 62.3502 217.229C63.7823 217.119 61.1385 215.797 61.1385 215.797C61.1385 215.797 58.6049 214.255 57.0577 212.928C55.5155 211.606 54.4139 211.055 54.4139 211.055H54.4089Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4983 207.856C57.4983 207.856 54.5191 209.839 54.4089 211.055C54.2988 212.267 57.6085 215.467 58.1593 215.907C58.7101 216.348 62.5706 217.339 63.7823 217.119C64.994 216.899 65.4346 216.017 65.4346 216.017C65.4346 216.017 61.6843 213.148 60.6929 211.606C59.7015 210.064 58.4897 207.195 58.4897 207.195L57.4983 207.856Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5746 203.004C61.5746 203.004 57.2734 204.105 57.2734 205.648C57.2734 207.19 59.1461 211.821 60.1425 212.813C61.1389 213.804 64.5538 216.784 65.4351 216.012C66.3163 215.241 65.7655 214.47 65.5452 213.699C65.3249 212.928 62.7863 206.424 62.7863 206.424L61.5746 203.004Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5243 206.203C68.5243 206.203 64.8841 213.038 65.5451 213.699C66.206 214.36 67.4177 215.021 67.9685 214.69C68.5193 214.36 70.8376 211.381 71.4986 209.728C72.1595 208.076 71.7189 207.415 70.7275 206.639C69.736 205.868 68.5243 206.198 68.5243 206.198V206.203Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5923 217.209C78.5923 216.573 78.0766 216.058 77.4407 216.058C76.8048 216.058 76.2891 216.573 76.2891 217.209C76.2891 217.845 76.8048 218.361 77.4407 218.361C78.0766 218.361 78.5923 217.845 78.5923 217.209Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1449 216.829H45.9805V218.471H77.1449V216.829Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 216.829H77.8359V218.471H109V216.829Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.117 218.466H177.754",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17578 218.466H170.619",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9745 67.0658L75.3172 46.106C70.2249 51.6088 67.1055 58.9743 67.1055 67.0658C67.1055 84.1151 80.9252 97.9348 97.9745 97.9348C108.87 97.9348 118.439 92.2868 123.931 83.7646L97.9745 67.0658Z",
    fill: "#878787",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3164 46.1059L97.9737 67.0658L123.931 83.7646C127.035 78.9477 128.843 73.2195 128.843 67.0658C128.843 50.0165 115.023 36.1968 97.9737 36.1968C89.0159 36.1968 80.9544 40.0172 75.3164 46.1109V46.1059Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9754 67.0659L90.7852 97.0887C93.0934 97.6395 95.4969 97.9399 97.9754 97.9399C108.871 97.9399 118.44 92.2919 123.932 83.7697L97.9754 67.0709V67.0659Z",
    fill: "#B8B8B8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7492 97.0784L97.9745 67.0656L67.1155 66.585C67.1155 66.7452 67.1055 66.9054 67.1055 67.0656C67.1055 81.6264 77.1898 93.8238 90.7492 97.0784Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.129 54.6731L133.125 43.1567",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1477 83.334L63.4883 93.2431",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5417 56.5509L57.6562 46.4165",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.875 90.0283L113.575 107.123H125.446",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9734 88.1757C109.632 88.1757 119.083 78.7244 119.083 67.0657C119.083 55.4069 109.632 45.9556 97.9734 45.9556C86.3146 45.9556 76.8633 55.4069 76.8633 67.0657C76.8633 78.7244 86.3146 88.1757 97.9734 88.1757Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.361 65.308C104.573 63.165 101.068 63.4003 100.407 65.959C99.9266 67.8066 100.723 70.2751 103.647 70.0598C103.427 71.8073 101.889 73.4897 100.382 74.396C98.8701 75.3073 96.7972 74.8917 96.7972 73.2644C96.7972 71.4618 96.7972 69.6993 96.7972 67.4911C99.4309 67.4911 100.793 67.7765 99.7764 66.7401C97.5783 64.4919 98.1491 64.8073 96.7972 64.8073C96.7972 60.2859 96.8122 60.346 96.7521 59.8252C96.2414 55.4039 92.5561 55.5341 91.1191 56.9661C90.4331 57.6521 90.8537 58.3731 91.5397 59.67C91.77 60.1006 92.1005 59.4196 93.0518 59.685C94.3286 60.0405 94.0182 60.6664 94.0182 64.8123C88.6856 64.8123 88.986 64.3266 91.9202 67.361C92.0955 67.5462 92.2907 67.4962 93.4274 67.4962C94.2135 67.4962 94.0182 67.2107 94.0182 68.9582C94.0182 74.3709 93.9231 74.2808 94.2586 74.9167C95.7557 77.7908 99.7964 79.0326 103.497 76.3538C107.252 73.6299 109.08 68.5627 106.361 65.303V65.308ZM96.2464 73.2694C96.2464 74.3159 96.9674 75.1571 98.0339 75.3574C102.095 76.1234 105.495 69.3638 103.802 69.499C103.191 69.5491 102.666 69.5491 102.055 69.2687C100.948 68.7579 100.653 67.2157 100.943 66.0992C101.494 63.9711 104.453 63.881 105.94 65.6635C107.608 67.6614 107.367 70.6006 105.975 72.8538C102.515 78.4518 96.682 78.3666 94.7492 74.6664C94.4989 74.1907 94.574 74.5262 94.574 68.9632C94.574 66.5798 94.8043 66.9454 93.4324 66.9454C91.9953 66.9454 92.5812 67.2558 90.7686 65.3631C94.3787 65.3631 94.574 65.4733 94.574 65.0877C94.574 60.7315 94.9495 59.64 93.202 59.1543C91.7099 58.7387 92.1255 59.9304 91.4395 58.1879C91.2793 57.7823 91.4495 57.3066 91.8401 57.1164C93.5676 56.2752 94.6691 56.6407 95.3601 57.562C97.0676 59.8503 95.6906 65.318 96.5168 65.3581C98.0139 65.4382 97.2278 64.9225 99.2006 66.9454C95.7156 66.9454 96.2464 66.4647 96.2464 68.7479",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7135 86.3481H25.5391V128.078H56.7135V86.3481Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 99.1113H53.273",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 105.005H53.273",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 123.17H53.273",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1953 99.3564V124.642",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1836 99.3564V124.642",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8203 99.3564V124.642",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6953 96.4225V90.4189H35.1724C35.4378 90.4189 35.6781 90.444 35.8934 90.494C36.1088 90.5441 36.294 90.6242 36.4492 90.7444C36.6045 90.8596 36.7246 91.0198 36.8097 91.2151C36.8949 91.4154 36.9349 91.6607 36.9349 91.9661C36.9349 92.2065 36.8999 92.4168 36.8348 92.587C36.7697 92.7623 36.6695 92.8975 36.5444 92.9976C36.4192 93.0978 36.254 93.1679 36.0637 93.2029C36.299 93.243 36.4993 93.3231 36.6545 93.4533C36.8097 93.5784 36.9249 93.7437 37.005 93.944C37.0851 94.1443 37.1202 94.3896 37.1202 94.68C37.1202 94.9704 37.0851 95.2208 37.01 95.4411C36.9399 95.6614 36.8298 95.8417 36.6896 95.9919C36.5494 96.1371 36.3741 96.2472 36.1638 96.3224C35.9535 96.3975 35.7082 96.4325 35.4278 96.4325H33.7003L33.6953 96.4225ZM34.7919 92.8724H35.1624C35.3777 92.8724 35.5479 92.8424 35.6681 92.7773C35.7883 92.7122 35.8684 92.6121 35.9185 92.4819C35.9635 92.3467 35.9886 92.1815 35.9886 91.9762C35.9886 91.7709 35.9535 91.6006 35.8834 91.4855C35.8133 91.3703 35.7032 91.2902 35.563 91.2501C35.4178 91.2101 35.2375 91.185 35.0122 91.185H34.7969V92.8775L34.7919 92.8724ZM34.7919 95.6514H35.2075C35.5379 95.6514 35.7633 95.5713 35.8834 95.4111C36.0036 95.2508 36.0637 95.0005 36.0637 94.665C36.0637 94.4247 36.0336 94.2244 35.9786 94.0742C35.9235 93.9239 35.8284 93.8088 35.6982 93.7387C35.568 93.6636 35.3927 93.6285 35.1774 93.6285H34.7969V95.6514H34.7919Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8555 96.4225V90.4189H38.937V96.4225H37.8555Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8633 96.4225V90.4189H40.9598V95.6664H42.4119V96.4225H39.8633Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9531 96.4225V90.4189H44.0497V95.6664H45.5018V96.4225H42.9531Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5608 96.5074C47.2003 96.5074 46.8999 96.4373 46.6545 96.2971C46.4142 96.1569 46.2289 95.9516 46.1037 95.6762C45.9786 95.4058 45.9135 95.0704 45.8984 94.6748L46.8398 94.4895C46.8498 94.7199 46.8798 94.9252 46.9249 95.1054C46.97 95.2857 47.0451 95.4209 47.1402 95.516C47.2353 95.6111 47.3655 95.6612 47.5208 95.6612C47.701 95.6612 47.8262 95.6061 47.8963 95.501C47.9714 95.3958 48.0064 95.2606 48.0064 95.0954C48.0064 94.835 47.9464 94.6197 47.8262 94.4495C47.706 94.2792 47.5508 94.114 47.3505 93.9438L46.5944 93.2778C46.3841 93.0975 46.2139 92.8923 46.0887 92.6669C45.9635 92.4416 45.8984 92.1662 45.8984 91.8307C45.8984 91.3551 46.0386 90.9895 46.314 90.7342C46.5894 90.4788 46.97 90.3486 47.4506 90.3486C47.731 90.3486 47.9664 90.3937 48.1567 90.4788C48.3469 90.5639 48.4921 90.6841 48.6073 90.8393C48.7175 90.9946 48.8026 91.1648 48.8577 91.3601C48.9127 91.5554 48.9478 91.7606 48.9628 91.981L48.0265 92.1462C48.0165 91.9559 47.9964 91.7907 47.9614 91.6405C47.9313 91.4903 47.8712 91.3751 47.7911 91.29C47.711 91.2049 47.5909 91.1648 47.4306 91.1648C47.2704 91.1648 47.1402 91.2199 47.0551 91.325C46.97 91.4302 46.9249 91.5654 46.9249 91.7206C46.9249 91.9209 46.965 92.0911 47.0501 92.2213C47.1352 92.3515 47.2554 92.4867 47.4156 92.6269L48.1667 93.2878C48.412 93.4931 48.6223 93.7385 48.8026 94.0189C48.9778 94.2993 49.068 94.6347 49.068 95.0303C49.068 95.3157 49.0029 95.5711 48.8777 95.7914C48.7525 96.0117 48.5773 96.187 48.3519 96.3121C48.1266 96.4373 47.8662 96.5024 47.5608 96.5024V96.5074Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8153 88.0577L27.4023 81.2095L18.2354 121.92L48.6483 128.768L57.8153 88.0577Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1836 94.4697L51.652 99.7573",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8867 100.218L50.3552 105.505",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7812 106.141L49.2497 111.429",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6797 112.064L48.1481 117.352",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8945 117.938L46.363 123.226",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7326 97.9995L37.1797 122.665",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0462 95.1406L24.4883 119.811",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2025 99.4565L43.6445 124.122",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1417 92.8325L34.4586 86.9741L35.8957 87.2996C36.156 87.3597 36.3863 87.4348 36.5866 87.5299C36.7869 87.625 36.9471 87.7452 37.0723 87.8954C37.1975 88.0456 37.2826 88.2209 37.3177 88.4362C37.3577 88.6465 37.3427 88.9019 37.2776 89.1923C37.2225 89.4276 37.1474 89.6229 37.0423 89.7781C36.9371 89.9333 36.812 90.0435 36.6668 90.1136C36.5215 90.1837 36.3463 90.2137 36.151 90.2087C36.3713 90.2989 36.5466 90.424 36.6718 90.5793C36.7969 90.7345 36.872 90.9197 36.9021 91.135C36.9321 91.3504 36.9171 91.5957 36.852 91.8761C36.7869 92.1565 36.6968 92.3968 36.5816 92.5921C36.4615 92.7924 36.3213 92.9476 36.151 93.0578C35.9808 93.168 35.7855 93.238 35.5652 93.2631C35.3449 93.2881 35.0945 93.2731 34.8191 93.208L33.1367 92.8275L33.1417 92.8325ZM34.9944 89.6079L35.3549 89.688C35.5652 89.7381 35.7354 89.7431 35.8656 89.703C35.9958 89.668 36.0959 89.5878 36.171 89.4677C36.2461 89.3475 36.3062 89.1873 36.3513 88.992C36.3964 88.7867 36.4014 88.6165 36.3513 88.4863C36.3062 88.3561 36.2211 88.2559 36.0909 88.1858C35.9607 88.1157 35.7855 88.0507 35.5702 88.0056L35.3599 87.9605L34.9894 89.6079H34.9944ZM34.3835 92.3217L34.7891 92.4119C35.1095 92.487 35.3499 92.4569 35.5001 92.3267C35.6503 92.1966 35.7655 91.9662 35.8356 91.6408C35.8906 91.4054 35.9057 91.2052 35.8806 91.0449C35.8606 90.8847 35.7905 90.7545 35.6803 90.6544C35.5702 90.5542 35.405 90.4791 35.1947 90.429L34.8241 90.3439L34.3785 92.3167L34.3835 92.3217Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1992 93.7436L38.5161 87.8853L39.5726 88.1256L38.2557 93.9839L37.1992 93.7486V93.7436Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1602 94.1894L40.477 88.3311L41.5486 88.5714L40.3969 93.6937L41.8139 94.0141L41.6487 94.7502L39.1602 94.1894Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1758 94.8652L43.4927 89.0068L44.5642 89.2472L43.4125 94.3695L44.8296 94.6899L44.6643 95.426L42.1758 94.8652Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6455 95.9569C46.295 95.8768 46.0146 95.7416 45.8094 95.5513C45.6041 95.3611 45.4689 95.1207 45.4088 94.8253C45.3487 94.5349 45.3537 94.1944 45.4238 93.8039L46.3852 93.8289C46.3451 94.0592 46.3251 94.2645 46.3351 94.4498C46.3401 94.635 46.3802 94.7852 46.4553 94.9004C46.5304 95.0156 46.6405 95.0907 46.7958 95.1257C46.971 95.1658 47.1062 95.1408 47.2013 95.0506C47.2965 94.9655 47.3616 94.8403 47.3966 94.6801C47.4517 94.4247 47.4417 94.1994 47.3666 94.0141C47.2865 93.8239 47.1713 93.6236 47.0161 93.4183L46.4252 92.6021C46.26 92.3768 46.1398 92.1415 46.0647 91.8961C45.9896 91.6508 45.9896 91.3654 46.0647 91.0399C46.1699 90.5793 46.3852 90.2488 46.7106 90.0585C47.0361 89.8682 47.4367 89.8282 47.9023 89.9333C48.1777 89.9934 48.398 90.0886 48.5583 90.2137C48.7235 90.3389 48.8437 90.4891 48.9188 90.6644C48.9939 90.8396 49.0339 91.0249 49.044 91.2302C49.054 91.4305 49.044 91.6408 49.0089 91.8561L48.0626 91.811C48.0926 91.6257 48.1126 91.4555 48.1126 91.3053C48.1126 91.1551 48.0826 91.0299 48.0225 90.9298C47.9624 90.8296 47.8523 90.7645 47.697 90.7295C47.5368 90.6944 47.4066 90.7195 47.2965 90.8046C47.1863 90.8897 47.1162 91.0099 47.0812 91.1651C47.0361 91.3604 47.0411 91.5356 47.0962 91.6808C47.1513 91.826 47.2364 91.9863 47.3616 92.1565L47.9474 92.9627C48.1427 93.218 48.2929 93.5034 48.4031 93.8139C48.5132 94.1243 48.5232 94.4748 48.4381 94.8604C48.373 95.1408 48.2578 95.3761 48.0876 95.5614C47.9174 95.7516 47.7071 95.8818 47.4617 95.9569C47.2164 96.032 46.946 96.032 46.6506 95.9669L46.6455 95.9569Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.365 111.168V119.841H137.472V111.168H131.098V123.842C131.098 124.823 131.894 125.619 132.875 125.619H135.689C136.671 125.619 137.467 124.823 137.467 123.842V123.256H140.556L142.003 122.334H166.703L168.541 123.386H171.365V123.842C171.365 124.823 172.161 125.619 173.143 125.619H175.957C176.938 125.619 177.734 124.823 177.734 123.842V111.168H171.36H171.365Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.419 104.93C176.183 104.459 174.461 102.656 174.115 102.301C174.075 102.261 174.04 102.211 174.015 102.161C173.595 101.355 170.02 95.4713 169.394 94.2996C168.242 92.1565 167.321 92.477 166.094 92.3218C166.059 92.3218 166.024 92.3268 165.984 92.3218L156.656 91.8511C155.118 91.771 153.581 91.771 152.044 91.8511C149.52 91.9763 146.997 92.1015 144.473 92.2316C142.365 92.3368 140.337 92.2016 139.181 94.2996C138.54 95.4612 134.98 101.35 134.559 102.161C134.534 102.211 134.499 102.261 134.459 102.301C134.113 102.662 132.391 104.459 132.156 104.93C131.895 105.455 130.844 107.428 130.844 107.819C130.844 108.159 131.089 113.777 132.166 118.184C132.486 119.495 133.483 120.547 134.784 120.918C134.874 120.943 134.945 120.958 134.985 120.958H143.166C143.387 120.958 143.592 120.837 143.702 120.647L145.64 117.302C145.68 117.237 145.73 117.177 145.785 117.132C146.09 116.887 147.117 116.161 148.649 116.161H159.945C161.472 116.161 162.504 116.887 162.809 117.132C162.869 117.182 162.919 117.237 162.955 117.302L164.892 120.647C165.002 120.837 165.208 120.958 165.428 120.958H173.61C173.645 120.958 173.715 120.943 173.805 120.918C175.107 120.552 176.098 119.5 176.424 118.184C177.505 113.777 177.746 108.159 177.746 107.819C177.746 107.423 176.694 105.455 176.434 104.93H176.419ZM136.287 100.724C137.929 97.5042 141.018 93.5736 141.018 93.5736C156.06 92.0614 167.621 93.5085 167.621 93.5085L172.088 100.724C161.908 99.7373 136.287 100.724 136.287 100.724Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.515 120.958L143.055 122.009H165.386L165.056 120.958L162.888 117.212C162.888 117.212 162.032 116.226 159.934 116.161C157.831 116.096 148.638 116.161 148.638 116.161C148.638 116.161 147.06 116.031 145.683 117.212L143.515 120.958Z",
    fill: "#787878",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.415 108.475C145.415 108.475 147.188 111.629 147.713 112.155C148.239 112.681 148.83 112.681 149.551 112.746C150.272 112.811 160.191 112.746 160.191 112.746C160.191 112.746 160.977 112.616 161.373 112.025C161.768 111.434 163.08 108.48 163.08 108.48H145.41L145.415 108.475Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.18 108.905C147.18 108.905 148.602 111.429 149.022 111.849C149.443 112.27 149.919 112.27 150.494 112.325C151.075 112.375 159.017 112.325 159.017 112.325C159.017 112.325 159.647 112.22 159.963 111.744C160.278 111.269 161.33 108.905 161.33 108.905H147.18Z",
    fill: "#787878",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.665 119.841L161.274 118.754C161.024 118.068 160.368 117.618 159.637 117.633L148.966 117.738C148.215 117.753 147.559 118.259 147.359 118.985L147.094 119.841H161.665Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.927 120.367L146.602 121.418H162.234L161.853 120.367H146.927Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.059 102.236C174.059 102.236 174.389 99.6724 174.98 99.6724C175.571 99.6724 178.199 100.393 178.265 100.919C178.33 101.445 177.739 102.036 177.213 102.166C176.687 102.296 175.571 102.426 175.571 102.426L175.31 103.413L174.064 102.231L174.059 102.236Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.516 102.236C134.516 102.236 134.185 99.6724 133.594 99.6724C133.003 99.6724 130.375 100.393 130.31 100.919C130.245 101.445 130.835 102.036 131.361 102.166C131.887 102.296 133.003 102.426 133.003 102.426L133.264 103.413L134.511 102.231L134.516 102.236Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.138 108.149C142.138 108.149 143.32 109.396 143.716 111.694C143.716 111.694 138.133 111.434 135.965 110.578C133.796 109.721 133.536 109.656 133.466 109.266C133.396 108.875 133.596 106.046 134.452 105.586C135.309 105.125 136.225 105.255 137.081 105.916C137.937 106.572 138.984 107.558 139.58 107.754C140.171 107.949 142.143 108.149 142.143 108.149H142.138Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.768 109.877C137.617 109.877 138.305 109.188 138.305 108.339C138.305 107.49 137.617 106.802 136.768 106.802C135.919 106.802 135.23 107.49 135.23 108.339C135.23 109.188 135.919 109.877 136.768 109.877Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.061 110.262C141.061 110.658 140.741 110.978 140.345 110.978C139.949 110.978 139.629 110.658 139.629 110.262C139.629 109.867 139.949 109.546 140.345 109.546C140.741 109.546 141.061 109.867 141.061 110.262Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.62 108.149C166.62 108.149 165.439 109.396 165.043 111.694C165.043 111.694 170.626 111.434 172.794 110.578C174.962 109.721 175.222 109.656 175.288 109.266C175.353 108.875 175.157 106.046 174.301 105.586C173.445 105.125 172.529 105.255 171.672 105.916C170.816 106.572 169.77 107.558 169.174 107.754C168.583 107.949 166.61 108.149 166.61 108.149H166.62Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.801 108.339C170.801 109.191 171.492 109.877 172.338 109.877C173.184 109.877 173.875 109.186 173.875 108.339C173.875 107.493 173.184 106.802 172.338 106.802C171.492 106.802 170.801 107.493 170.801 108.339Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.055 110.262C168.055 110.658 168.375 110.978 168.771 110.978C169.166 110.978 169.487 110.658 169.487 110.262C169.487 109.867 169.166 109.546 168.771 109.546C168.375 109.546 168.055 109.867 168.055 110.262Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.668 113.992C173.668 113.992 167.559 115.174 167.294 115.369C167.034 115.565 166.508 116.681 166.508 116.681L167.755 116.351C167.755 116.351 170.644 116.481 171.63 116.02C172.617 115.56 173.668 113.982 173.668 113.982V113.992Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.367 113.992C135.367 113.992 141.476 115.174 141.741 115.369C142.002 115.565 142.527 116.681 142.527 116.681L141.281 116.351C141.281 116.351 138.392 116.481 137.405 116.02C136.419 115.56 135.367 113.982 135.367 113.982V113.992Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.005 109.161L164.378 108.615H163.086",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.859 109.081L143.946 108.46L145.418 108.475",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.633 101.81C170.798 101.715 170.968 101.625 171.134 101.545",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.402 111.139C164.429 108.88 166.782 104.389 170.062 102.171",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82 112.5C162.82 112.5 162.9 112.285 163.056 111.915",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.502 102.166C138.232 102.001 137.947 101.845 137.656 101.7",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.081 111.189C144.41 109.181 142.657 105.02 139.082 102.542",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.421 112.345C145.421 112.345 145.371 112.135 145.266 111.774",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.787 105.35C135.787 105.35 135.086 103.643 135.086 102.631L135.787 105.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.787 105.35C135.787 105.35 135.086 103.643 135.086 102.631",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.156 105.275C173.156 105.275 173.392 104.499 173.547 103.102L173.156 105.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.156 105.275C173.156 105.275 173.392 104.499 173.547 103.102",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.562 112.576L175.097 118.634L166.474 119.025C166.474 119.025 164.997 117.237 164.922 116.461C164.842 115.685 165.934 114.518 166.244 114.443C166.554 114.363 171.992 113.277 171.992 113.277",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.379 112.576L133.845 118.634L142.467 119.025C142.467 119.025 143.944 117.237 144.019 116.461C144.099 115.685 143.008 114.518 142.697 114.443C142.387 114.368 136.949 113.277 136.949 113.277",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.793 109.942L154.132 110.448C154.402 110.468 154.673 110.468 154.943 110.448L160.786 109.992",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.211 110.603L154.129 111.079C154.4 111.099 154.67 111.099 154.941 111.079L160.579 110.643",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.637 111.269L154.135 111.709C154.405 111.729 154.675 111.729 154.946 111.709L160.298 111.294",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.289 100.724C136.289 100.724 161.906 99.7374 172.09 100.724L167.624 93.5086C167.624 93.5086 156.062 92.0615 141.021 93.5736C141.021 93.5736 137.931 97.5042 136.289 100.724Z",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.165 23.5039H128.801V40.0275H181.165V23.5039Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.054 8.42725L128.941 23.5037H181.166L155.054 8.42725Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.591 22.1616H152.633V40.0271H165.591V22.1616Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.591 22.1616H152.633V22.9227H165.591V22.1616Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.348 40.0324H155.879V28.8664C155.879 27.0789 157.326 25.6318 159.114 25.6318C160.901 25.6318 162.348 27.0789 162.348 28.8664V40.0324Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.057 26.3979H125.039V40.0274H155.057V26.3979Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.057 26.3979H125.039V27.0038H155.057V26.3979Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.752 27.5244H128.344V40.0322H151.752V27.5244Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05 16.4287L124.117 25.6268H155.978L140.05 16.4287Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.978 25.627H124.117V26.4031H155.978V25.627Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.114 16.9746L150.867 21.7414H167.366L159.114 16.9746Z",
    fill: "#645faa",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.366 21.7412H150.867V22.5073H167.366V21.7412Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.093 28.5308H129.195V30.4285H131.093V28.5308Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.937 28.5308H132.039V30.4285H133.937V28.5308Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.781 28.5308H134.883V30.4285H136.781V28.5308Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.624 28.5308H137.727V30.4285H139.624V28.5308Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.468 28.5308H140.57V30.4285H142.468V28.5308Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 28.5308H143.414V30.4285H145.312V28.5308Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.156 28.5308H146.258V30.4285H148.156V28.5308Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.003 28.5308H149.105V30.4285H151.003V28.5308Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.093 31.3198H129.195V33.2175H131.093V31.3198Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.937 31.3198H132.039V33.2175H133.937V31.3198Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.781 31.3198H134.883V33.2175H136.781V31.3198Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.624 31.3198H137.727V33.2175H139.624V31.3198Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.468 31.3198H140.57V33.2175H142.468V31.3198Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 31.3198H143.414V33.2175H145.312V31.3198Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.156 31.3198H146.258V33.2175H148.156V31.3198Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.003 31.3198H149.105V33.2175H151.003V31.3198Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.093 34.1089H129.195V36.0066H131.093V34.1089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.937 34.1089H132.039V36.0066H133.937V34.1089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.781 34.1089H134.883V36.0066H136.781V34.1089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.624 34.1089H137.727V36.0066H139.624V34.1089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.468 34.1089H140.57V36.0066H142.468V34.1089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 34.1089H143.414V36.0066H145.312V34.1089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.156 34.1089H146.258V36.0066H148.156V34.1089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.003 34.1089H149.105V36.0066H151.003V34.1089Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.093 36.8975H129.195V38.7952H131.093V36.8975Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.937 36.8975H132.039V38.7952H133.937V36.8975Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.781 36.8975H134.883V38.7952H136.781V36.8975Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.624 36.8975H137.727V38.7952H139.624V36.8975Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.468 36.8975H140.57V38.7952H142.468V36.8975Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 36.8975H143.414V38.7952H145.312V36.8975Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.156 36.8975H146.258V38.7952H148.156V36.8975Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.003 36.8975H149.105V38.7952H151.003V36.8975Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.651 40.0325H163.504V22.162L173.078 16.9746L182.651 22.162V40.0325Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.112 22.9227L173.077 16.9442L162.041 22.9227L161.695 22.2868L173.077 16.123L184.458 22.2868L184.112 22.9227Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.504 22.162V22.5976L173.078 17.4102L182.651 22.5976V22.162L173.078 16.9746L163.504 22.162Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.601 28.2852H173.387V30.5183H176.601V28.2852Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.601 31.2544H173.387V33.4876H176.601V31.2544Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.601 25.1709H173.387V27.5543H176.601V25.1709Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.652 25.1709H169.438V27.5543H172.652V25.1709Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.652 31.2544H169.438V33.4876H172.652V31.2544Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.652 28.2852H169.438V30.5183H172.652V28.2852Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.601 34.2188H173.387V36.2717H176.601V34.2188Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.652 34.2188H169.438V36.2717H172.652V34.2188Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_479_5001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 226.207,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanApply);
export default __webpack_public_path__ + "static/media/loan_apply.6c7a5483542ba201098a01c0c56ec2e5.svg";
export { ForwardRef as ReactComponent };